import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';

export const TextArea = forwardRef(({ label, error, className = '', rows = 4, ...props }, ref) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-slate-700 mb-1.5 tracking-tight">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          "block w-full rounded-xl border px-3.5 py-2.5 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-4 transition-all duration-200 sm:text-sm shadow-sm",
          error 
            ? "border-red-300 focus:border-red-500 focus:ring-red-500/20" 
            : "border-slate-200 hover:border-slate-300 focus:border-meetoi-navy focus:ring-meetoi-navy/10",
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-1.5 text-sm text-red-600 font-medium">{error}</p>
      )}
    </div>
  );
});

TextArea.displayName = 'TextArea';